import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

declare let delta: any;

function _window(): any {
  // return the global native browser window object
  return window;
}

@Injectable({
  providedIn: 'root'
})
export class WindowRef {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  get nativewindow(): any {
    if (isPlatformBrowser(this.platformId)) {
      return _window();
    } else {
      return null;
    }
  }

  nativeWindow(): any {
    if (isPlatformBrowser(this.platformId)) {
      return _window();
    } else {
      return null;
    }
  }

  getHost(): any {
    if (this.nativeWindow()) {
      return this.nativeWindow().location.host;
    } else {
      return '';
    }
  }

  getProtocol(): any {
    if (this.nativeWindow()) {
      return this.nativeWindow().location.protocol;
    } else {
      return '';
    }
  }

  getPort(): any {
    if (this.nativeWindow()) {
      return this.nativeWindow().location.port;
    } else {
      return '';
    }
  }

  getOrigin(): any {
    if (this.nativeWindow()) {
      return this.nativeWindow().location.origin;
    } else {
      return '';
    }
  }
}
